import { useMutation } from '@tanstack/react-query'
import React from 'react'
import { downloadFinalZip } from 'services/apiReport'

const useDownloadZip = () => {
    const{isPending:isZipping, isSuccess:isZipped,mutate: downloadZip} = useMutation({
        mutationFn: downloadFinalZip,
    })

    return {isZipping,isZipped,downloadZip}
}

export default useDownloadZip
